"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const DEFAULT_FORM_AVATAR_SIZE = 36; exports.DEFAULT_FORM_AVATAR_SIZE = DEFAULT_FORM_AVATAR_SIZE

 const ENTITY_TYPES = {
  USER: 'USER',
  PATIENT: 'PATIENT',
  TEAM: 'TEAM',
  ORG: 'ORG',
  NEWPATIENT: 'NEWPATIENT',
  NEWUSER: 'NEWUSER',
  ADD: 'ADD',
  UNKNOWN: 'UNKNOWN',
} 

; exports.ENTITY_TYPES = ENTITY_TYPES

 const VALIDATION_STATES = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  NONE: "NONE",
} 

























; exports.VALIDATION_STATES = VALIDATION_STATES
